import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Profile.css";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode"; // Corrected import
import {
  ShowAllCategories,
  AddVendorDetails,
  ShowOneVendorDetail,
  ShowAllServiceLocation,
} from "../../../../context/Slice/VendorManagementSlice";
import {
  ShowUsersInfo,
  UpdateUser,
} from "../../../../context/Slice/RegisterSlice";
import { lookup } from "./index";
import Select from "react-select";
import { Autocomplete, TextField } from "@mui/material";
import cityData from "./indianCities.json";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Profile = () => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.VendorManagementR.AllCat);
  const locations = useSelector((state) => state.VendorManagementR.AllLoc);
  const Vendordetail = useSelector(
    (state) => state.VendorManagementR.Vendordetail
  );
  const UserInfo = useSelector((state) => state.RegisterR.AlluserData);

  const [formValues, setFormValues] = useState({
    id: "",
    OwnerName: "",
    OwnerEmail: "",
    OwnerMobile_number: "",
    OwnerWhatsapp_number: "",
    OwnerGender: "",
    OwnerCity: "",
    OwnerADDRESS: "",
    BusinessName: "",
    ServiceCategory_ID: [],
    OwnerImage: null,
    OwnerImageURL: null,
  });


  const [userValues, setUserValues] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    mobile_number: "",
  });
  const [pinCodeError, setPinCodeError] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();
  const token = secureLocalStorage.getItem("token");

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      setFormValues((prevValues) => ({
        ...prevValues,
        id: decoded._id,
      }));
      dispatch(ShowAllCategories());
      dispatch(ShowAllServiceLocation());
      dispatch(ShowOneVendorDetail(decoded._id));
      dispatch(ShowUsersInfo(decoded._id));
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (Vendordetail && Vendordetail.length > 0) {
      const details = Vendordetail[0];
      // Parse the OwnerImage field
      const parsedOwnerImage = JSON.parse(details.OwnerImage);
      const imageFilename = parsedOwnerImage[0]?.filename; // Extract the filename

      setFormValues((prevValues) => ({
        ...prevValues,
        OwnerName: details.OwnerName || "",
        OwnerEmail: details.OwnerEmail || "",
        OwnerMobile_number: details.OwnerMobile_number || "",
        OwnerWhatsapp_number: details.OwnerWhatsapp_number || "",
        OwnerGender: details.OwnerGender || "",
        OwnerCity: details.OwnerCity || "",
        OwnerADDRESS: details.OwnerADDRESS || "",
        BusinessName: details.BusinessName || "",
        ServiceCategory_ID: details.BusinessCategorises || "",
        OwnerImageURL: `${BASE_URL}/Uploads/${imageFilename}`, // Set the image URL
      }));
    }
    if (UserInfo) {
      setUserValues({
        firstName: UserInfo.firstName || "",
        lastName: UserInfo.lastName || "",
        email: UserInfo.email || "",
        mobile_number: UserInfo.mobile_number || "",
      });
    }
  }, [Vendordetail, UserInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  console.log("Data bei:", formValues);

  const handleLocationChange = (option) => {
    setSelectedLocation(option);
    setFormValues((prev) => ({
      ...prev,
      OwnerCity: option?.label || "", // Update location field dynamically
    }));
  };

  const handlePinCodeChange = (event) => {
    const { value } = event.target;
    setFormValues((prev) => ({ ...prev, OwnerADDRESS: value }));
    setShowSuggestions(true);

    // Get the location value dynamically from the location field
    const OwnerCity = formValues.OwnerCity.toLowerCase(); // Case-insensitive check for location

    if (OwnerCity) {
      if (value.length >= 3) {
        // Dynamically filter pincodes based on districtName matching the entered location
        const filteredSuggestions = lookup(value)
  .filter(
    (suggestion) =>
      suggestion.districtName.toLowerCase().includes(OwnerCity) || 
      suggestion.taluk.toLowerCase().includes(OwnerCity) || 
      suggestion.officeName.toLowerCase().includes(OwnerCity) || 
      suggestion.pincode.toString().includes(value) // Include pincode check
  )
  .slice(0, 10);

  console.log(filteredSuggestions)
        setSuggestions(filteredSuggestions);

        // Check if pincode matches city
        const isValidPinCode = filteredSuggestions.some((suggestion) =>
          suggestion.pincode.toString() === value || // Directly check pincode
          suggestion.officeName.toLowerCase().includes(OwnerCity) || // Check office name
          suggestion.taluk.toLowerCase().includes(OwnerCity) || // Check taluk name
          suggestion.districtName.toLowerCase().includes(OwnerCity) // Check district (fallback)
        );
        
        if (!isValidPinCode) {
          setPinCodeError("The pincode does not match the selected city.");
        } else {
          setPinCodeError(""); // Clear error if valid pincode
        }
      } else {
        setSuggestions([]); // If pin code length is less than 3, clear suggestions
      }
    } else {
      setSuggestions([]); // If location is empty, clear suggestions
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setFormValues((prev) => ({
      ...prev,
      OwnerADDRESS: suggestion.officeName,
    }));
    setSuggestions([]); // Clear suggestions
    setShowSuggestions(false); // Hide suggestions
  };

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setUserValues({
      ...userValues,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const { files } = e.target;
    if (files && files[0]) {
      setFormValues({
        ...formValues,
        OwnerImage: files[0],
        OwnerImageURL: URL.createObjectURL(files[0]),
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Data being sent:", formValues);

    dispatch(AddVendorDetails(formValues));
  };

  const serviceCategories = categories.map((category) => ({
    id: category.id,
    name: category.CategorieName,
  }));

  const handleUpdate = (e) => {
    e.preventDefault();
    const updatedLoginValues = { ...userValues, id: formValues.id }; // Include the id
    dispatch(UpdateUser(updatedLoginValues));
  };

  const HandleBack = () => {
    console.log("Back button clicked");
    navigate("/vendor-dashboard");
  };

  return (
    <div id="Profile-body" className="ProfileBody">
      {/* Back Button */}
      <Button
        variant="contained"
        color="secondary"
        onClick={HandleBack}
        sx={{ position: "absolute", top: "20px", left: "20px" }}
      >
        Back
      </Button>
      <div className="container-xl px-4 mt-4">
        <hr className="mt-0 mb-4" />
        <div className="row ">
          <div className="col-xl-4 ">
            <div className="card mb-4 mb-xl-0">
              <div className="card-header">Profile Picture</div>
              <div className="card-body text-center">
                <img
                  className="img-account-profile rounded-circle mb-2"
                  src={
                    formValues.OwnerImageURL ||
                    "https://www.bootdey.com/img/Content/avatar/avatar1.png"
                  }
                  alt="Profile"
                />
                <div className="small font-italic text-muted mb-4">
                  JPG or PNG no larger than 5 MB
                </div>
                <input
                  type="file"
                  id="profilePictureInput"
                  className="d-none"
                  accept="image/*"
                  name="OwnerImage"
                  onChange={handleFileChange}
                />
                <label htmlFor="profilePictureInput" className="btn btn-save">
                  Upload new image
                </label>
                {/* {formValues.OwnerImageURL && (
                  <div className="mt-2">
                    <small>Image Path: {formValues.OwnerImageURL}</small>
                  </div>
                )} */}
              </div>
              <form onSubmit={handleUpdate} autoComplete="off">
                <div className="col-lg-12 mb-4">
                  <label className="small mb-1" htmlFor="OwnerName">
                    First Name
                  </label>
                  <input
                    className="form-control"
                    id="firstName"
                    name="firstName"
                    type="text"
                    placeholder="Enter your First Name"
                    value={userValues.firstName}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg-12 mb-4">
                  <label className="small mb-1" htmlFor="OwnerEmail">
                    Last Name
                  </label>
                  <input
                    className="form-control"
                    id="lastName"
                    name="lastName"
                    type="text"
                    placeholder="Enter your Last Name"
                    value={userValues.lastName}
                    onChange={handleUserChange}
                  />
                </div>
                <div className="col-lg-12 mb-4">
                  <label className="small mb-1" htmlFor="OwnerEmail">
                    Email
                  </label>
                  <input
                    className="form-control"
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    value={userValues.email}
                    onChange={handleUserChange}
                  />
                </div>
                <div className="col-lg-12 mb-4">
                  <label className="small mb-1" htmlFor="OwnerEmail">
                    Mobile Number
                  </label>
                  <input
                    className="form-control"
                    id="mobile_number"
                    name="mobile_number"
                    type="text"
                    placeholder="Enter your  Mobile Number"
                    value={userValues.mobile_number}
                    onChange={handleUserChange}
                  />
                </div>

                <button className="btn btn-save  fs-4" type="submit">
                  Update
                </button>
              </form>
            </div>
          </div>
          <div className="col-xl-8">
            <div className="card mb-4">
              <div className="card-header">Details</div>
              <div className="card-body">
                <form onSubmit={handleSubmit} autoComplete="off">
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <label className="small mb-1" htmlFor="OwnerName">
                        Owner Name
                      </label>
                      <input
                        className="form-control"
                        id="OwnerName"
                        name="OwnerName"
                        type="text"
                        placeholder="Enter your name"
                        value={formValues.OwnerName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="small mb-1" htmlFor="OwnerEmail">
                        Business Email
                      </label>
                      <input
                        className="form-control"
                        id="OwnerEmail"
                        name="OwnerEmail"
                        type="email"
                        placeholder="Enter your email"
                        value={formValues.OwnerEmail}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <label
                        className="small mb-1"
                        htmlFor="OwnerMobile_number"
                      >
                        Business Mobile Number
                      </label>
                      <input
                        className="form-control"
                        id="OwnerMobile_number"
                        name="OwnerMobile_number"
                        type="tel"
                        placeholder="Enter your mobile number"
                        value={formValues.OwnerMobile_number}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label
                        className="small mb-1"
                        htmlFor="OwnerWhatsapp_number"
                      >
                        Business Whatsapp Number
                      </label>
                      <input
                        className="form-control"
                        id="OwnerWhatsapp_number"
                        name="OwnerWhatsapp_number"
                        type="tel"
                        placeholder="Enter your Whatsapp number"
                        value={formValues.OwnerWhatsapp_number}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <label className="small mb-1">Owner Gender</label>
                      <div>
                        <input
                          type="radio"
                          id="male"
                          name="OwnerGender"
                          value="male"
                          checked={formValues.OwnerGender === "male"}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="male" className="ms-1">
                          Male
                        </label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="female"
                          name="OwnerGender"
                          value="female"
                          checked={formValues.OwnerGender === "female"}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="female" className="ms-1">
                          Female
                        </label>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <label className="small mb-1" htmlFor="inputOwnerDOB">
                        Owner Date of Birth
                      </label>
                      <input
                        className="form-control"
                        id="inputOwnerDOB"
                        name="OwnerDOB"
                        type="date"
                        placeholder="Enter your date of birth"
                        value={formValues.OwnerDOB}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-12 col-md-6 left-border">
                      <label className="small mb-1" htmlFor="inputOwnerDOB">
                        Owner City
                      </label>
                      <div className="input-group" style={{ position: "relative", zIndex: 10 }}> 

                        <Select
                          className="form-control listing-category category-input"
                          placeholder="Select City"
                          options={locations.map((location) => ({
                            value: location.LocationName, // Store value as LocationName directly
                            label: location.LocationName, // Display LocationName as label
                          }))}
                          onChange={(selectedOption) => {
                            setFormValues((prev) => ({
                              ...prev,
                              OwnerCity: selectedOption
                                ? selectedOption.value
                                : "", // Store the selected city's value
                            }));
                          }}
                          value={
                            formValues.OwnerCity
                              ? {
                                  label: formValues.OwnerCity,
                                  value: formValues.OwnerCity,
                                }
                              : null
                          } // Set default value if exists
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label>Owner Business Address</label>
                      <input
                        className="form-control"
                        type="text"
                        name="city"
                        value={formValues.OwnerADDRESS}
                        onChange={handlePinCodeChange}
                        placeholder="Enter Area Name or Pin Code"
                        required
                      />
                      {pinCodeError && (
                        <div className="error-message">{pinCodeError}</div>
                      )}
                      {showSuggestions && suggestions.length > 0 && (
                        <ul className="suggestions-list">
                          {suggestions.map((suggestion, index) => (
                            <li
                              key={index}
                              className="suggestion-item"
                              onClick={() => handleSuggestionClick(suggestion)}
                            >
                              {suggestion.officeName} ({suggestion.pincode})
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="row gx-3 mb-3">
                    <div className="col-md-6">
                      <label className="small mb-1" htmlFor="inputBusinessName">
                        Business Name
                      </label>
                      <input
                        className="form-control"
                        id="inputBusinessName"
                        name="BusinessName"
                        type="text"
                        placeholder="Enter your business name"
                        value={formValues.BusinessName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {/* <div className="col-md-6">
                                            <label className="small mb-1">Business Categories</label>
                                        <div>
                                            {serviceCategories.map((category) => (
                                                <div key={category.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`category-${category.id}`}
                                                        name="ServiceCategory_ID"
                                                        value={category.id}
                                                        checked={formValues.ServiceCategory_ID.includes(category.id)}
                                                        onChange={(e) => {
                                                          const { checked, value } = e.target;
                                                          const categoryId = parseInt(value, 10); // Parse value as integer
                                                          setFormValues((prevValues) => ({
                                                            ...prevValues,
                                                            ServiceCategory_ID: checked
                                                              ? [...prevValues.ServiceCategory_ID, categoryId]
                                                              : prevValues.ServiceCategory_ID.filter((id) => id !== categoryId),
                                                          }));
                                                        }}                                                        
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={`category-${category.id}`}
                                                    >
                                                        {category.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div> */}
                  </div>
                  <button className="btn btn-save fs-4" type="submit">
                    Save changes
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
